<div class="meine-benutzer-page">
    <div class="list-title-row">
        <button *ngIf="showBackButton" mat-icon-button color="accent" (click)="back()">
            <mat-icon>arrow_back</mat-icon>
        </button>
        <h3 class="list-title">Meine Benutzer ({{ getFilteredBenutzerList().length || 0 }})</h3>
        <span class="spacer"></span>
        <button mat-icon-button color="accent" (click)="benutzerHinzufuegen()">
            <mat-icon>add</mat-icon>
        </button>
    </div>
    <div class="search-container">
        <mat-form-field appearance="outline" class="search-field">
            <mat-label>Benutzer durchsuchen...</mat-label>
            <input matInput [(ngModel)]="searchTerm" placeholder="Nach Benutzer, E-Mail oder Benutzerrollen suchen..." />
            <span matSuffix class="search-suffix">
                <button *ngIf="searchTerm" mat-icon-button (click)="searchTerm = ''" aria-label="Suche löschen">
                    <mat-icon>close</mat-icon>
                </button>
                <mat-icon class="search-suffix-icon">search</mat-icon>
            </span>
        </mat-form-field>
    </div>
    <div class="mobile-cards" *ngIf="isMobileScreen; else desktopTable">
        <div class="mobile-card" *ngFor="let b of getSortedFilteredBenutzerList()">
            <div class="mobile-card__header">
                <div class="mobile-card__title-wrap">
                    <div class="mobile-card__title">{{ b.vorname }} {{ b.nachname }}</div>
                </div>
                <button mat-icon-button [matMenuTriggerFor]="benutzerMenuMobile" class="options-button">
                    <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #benutzerMenuMobile="matMenu" xPosition="before" yPosition="below">
                    <button mat-menu-item (click)="betriebeEditieren(b)">
                        <mat-icon>business</mat-icon>
                        <span>Betriebe bearbeiten</span>
                    </button>
                    <button mat-menu-item (click)="rollenEditieren(b)">
                        <mat-icon>people</mat-icon>
                        <span>Benutzerrollen bearbeiten</span>
                    </button>
                    <button mat-menu-item (click)="benutzerEntfernen(b)">
                        <mat-icon>delete</mat-icon>
                        <span>l&ouml;schen</span>
                    </button>
                </mat-menu>
            </div>
            <div class="mobile-card__grid">
                <div class="mobile-card__item">
                    <span class="mobile-card__label">Benutzer</span>
                    <span class="mobile-card__value">{{ b.vorname }} {{ b.nachname }}</span>
                </div>
                <div class="mobile-card__item">
                    <span class="mobile-card__label">E-Mail</span>
                    <span class="mobile-card__value">{{ b.email || '-' }}</span>
                </div>
                <div class="mobile-card__item">
                    <span class="mobile-card__label">Betriebe</span>
                    <span class="mobile-card__value">{{ getBetriebeText(b) || '-' }}</span>
                </div>
                <div class="mobile-card__item">
                    <span class="mobile-card__label">Benutzerrollen</span>
                    <span class="mobile-card__value">{{ getBenutzerrollenText(b) || '-' }}</span>
                </div>
            </div>
        </div>
    </div>

    <ng-template #desktopTable>
        <div class="list-wrapper">
            <div class="list-header">
                <button class="sort-header" type="button" (click)="setSort('benutzer')">
                    Benutzer
                    <mat-icon class="sort-icon" *ngIf="sortField === 'benutzer'">{{
                        sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward'
                    }}</mat-icon>
                </button>
                <button class="sort-header" type="button" (click)="setSort('email')">
                    Email
                    <mat-icon class="sort-icon" *ngIf="sortField === 'email'">{{
                        sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward'
                    }}</mat-icon>
                </button>
                <button class="sort-header" type="button" (click)="setSort('betriebe')">
                    Betriebe
                    <mat-icon class="sort-icon" *ngIf="sortField === 'betriebe'">{{
                        sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward'
                    }}</mat-icon>
                </button>
                <button class="sort-header" type="button" (click)="setSort('benutzerrollen')">
                    Benutzerrollen
                    <mat-icon class="sort-icon" *ngIf="sortField === 'benutzerrollen'">{{
                        sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward'
                    }}</mat-icon>
                </button>
                <span></span>
            </div>
            <ng-container *ngFor="let b of getSortedFilteredBenutzerList()">
                <div class="list-row">
                    <span class="row-cell">
                        <span class="mobile-field-label">Benutzer:</span>
                        <strong>{{ b.vorname }} {{ b.nachname }}</strong>
                    </span>
                    <span class="row-cell user-email">
                        <span class="mobile-field-label">Email:</span>
                        <span class="mobile-field-value">{{ b.email || '-' }}</span>
                    </span>
                    <span class="row-cell">
                        <span class="mobile-field-label">Betriebe:</span>
                        <ng-container *ngIf="b?.kunden?.length; else noBetriebe">
                            <span *ngFor="let k of b.kunden; let i = index">
                                {{ k.bezeichnung_final }} - {{ k.zusatz_final }}<span *ngIf="i < b.kunden.length - 1">, </span>
                            </span>
                        </ng-container>
                        <ng-template #noBetriebe>-</ng-template>
                    </span>
                    <span class="row-cell">
                        <span class="mobile-field-label">Benutzerrollen:</span>
                        <ng-container *ngIf="b?.benutzerrollen?.length; else noRollen">
                            <span *ngFor="let r of b.benutzerrollen; let i = index">
                                {{ r.bezeichnung }}<span *ngIf="i < b.benutzerrollen.length - 1">, </span>
                            </span>
                        </ng-container>
                        <ng-template #noRollen>-</ng-template>
                    </span>
                    <span class="row-actions">
                        <button mat-icon-button [matMenuTriggerFor]="benutzerMenu" class="options-button">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #benutzerMenu="matMenu" xPosition="before" yPosition="below">
                            <button mat-menu-item (click)="betriebeEditieren(b)">
                                <mat-icon>business</mat-icon>
                                <span>Betriebe bearbeiten</span>
                            </button>
                            <button mat-menu-item (click)="rollenEditieren(b)">
                                <mat-icon>people</mat-icon>
                                <span>Benutzerrollen bearbeiten</span>
                            </button>
                            <button mat-menu-item (click)="benutzerEntfernen(b)">
                                <mat-icon>delete</mat-icon>
                                <span>l&ouml;schen</span>
                            </button>
                        </mat-menu>
                    </span>
                </div>
            </ng-container>
        </div>
    </ng-template>
</div>
